import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import type { TSelector } from "../../../i18n/types";

type MetricLabelKey =
  | "ACOS"
  | "Spend"
  | "Sales"
  | "CTR"
  | "CVR"
  | "Conv."
  | "Cost"
  | "CPC"
  | "Impr."
  | "Clicks"
  | "Hours"
  | "Target ACOS Max"
  | "Target ACOS Min"
  | "ToS Share"
  | "ROAS"
  | "Budget"
  | "Bid";

const metricLabels: Record<string, MetricLabelKey> = {
  acos: "ACOS",
  acos_delta: "ACOS",
  ad_spend: "Spend",
  spend: "Spend",
  spend_delta: "Spend",
  ad_sales: "Sales",
  ad_sales_delta: "Sales",
  sales: "Sales",
  click_thru_rate: "CTR",
  click_thru_rate_delta: "CTR",
  conv_rate: "CVR",
  conv_rate_delta: "CVR",
  conversions: "Conv.",
  cost: "Cost",
  cost_per_click: "CPC",
  cost_per_click_delta: "CPC",
  impressions: "Impr.",
  clicks: "Clicks",
  serving_hours: "Hours",
  serving_hours_delta: "Hours",
  target_acos_max: "Target ACOS Max",
  target_acos_min: "Target ACOS Min",
  top_of_search_impression_share: "ToS Share",
  top_of_search_impression_share_delta: "ToS Share",
  roas: "ROAS",
  roas_delta: "ROAS",
  daily_budget: "Budget",
  bid: "Bid",
};

const METRIC_LABEL_SELECTORS: Record<MetricLabelKey, TSelector> = {
  ACOS: ($) => $.chat.metricLabels["ACOS"],
  Spend: ($) => $.chat.metricLabels["Spend"],
  Sales: ($) => $.chat.metricLabels["Sales"],
  CTR: ($) => $.chat.metricLabels["CTR"],
  CVR: ($) => $.chat.metricLabels["CVR"],
  "Conv.": ($) => $.chat.metricLabels["Conv."],
  Cost: ($) => $.chat.metricLabels["Cost"],
  CPC: ($) => $.chat.metricLabels["CPC"],
  "Impr.": ($) => $.chat.metricLabels["Impr."],
  Clicks: ($) => $.chat.metricLabels["Clicks"],
  Hours: ($) => $.chat.metricLabels["Hours"],
  "Target ACOS Max": ($) => $.chat.metricLabels["Target ACOS Max"],
  "Target ACOS Min": ($) => $.chat.metricLabels["Target ACOS Min"],
  "ToS Share": ($) => $.chat.metricLabels["ToS Share"],
  ROAS: ($) => $.chat.metricLabels["ROAS"],
  Budget: ($) => $.chat.metricLabels["Budget"],
  Bid: ($) => $.chat.metricLabels["Bid"],
};

export const useMetricLabel = (): ((key: string) => string) => {
  const { t } = useTranslation("chat");
  return useCallback(
    (key: string): string => {
      const labelKey = metricLabels[key];
      return labelKey ?
          t(METRIC_LABEL_SELECTORS[labelKey])
        : key.replaceAll("_", " ").replaceAll(/\b\w/g, (l) => l.toUpperCase());
    },
    [t],
  );
};
